export const NEW_COLLABORATOR = '[Collaborator] New collaborator';

export const CREATE_COLLABORATOR = '[Collaborator] Create collaborator';
export const CREATE_ARTIST_COLLABORATOR =
  '[Collaborator] Create artist collaborator';
export const CREATE_COLLABORATOR_SUCCESS =
  '[Collaborator] Create collaborator Success';
export const CREATE_COLLABORATOR_ERROR =
  '[Collaborator] Create collaborator Error';

export const UPDATE_COLLABORATOR_FIELD =
  '[Collaborator] Update collaborator field';

export const GET_COLLABORATORS = '[Collaborator] Get collaborators';
export const GET_COLLABORATORS_SUCCESS =
  '[Collaborator] Get collaborators Success';
export const GET_COLLABORATORS_ERROR = '[Collaborator] Get collaborators Error';

export const UPDATE_COLLABORATOR = '[Collaborator] Update collaborator';
export const UPDATE_COLLABORATOR_SUCCESS =
  '[Collaborator] Update collaborator Success';
export const UPDATE_COLLABORATOR_ERROR =
  '[Collaborator] Update collaborator Error';

export const UPDATE_COLLABORATOR_ORDER =
  '[Collaborator] Update collaborator order';
export const UPDATE_COLLABORATOR_ORDER_SUCCESS =
  '[Collaborator] Update collaborator order Success';
export const UPDATE_COLLABORATOR_ORDER_ERROR =
  '[Collaborator] Update collaborator order Error';

export const REASSIGN_SPLITS = '[Collaborator] Reassign Splits';
export const REASSIGN_SPLITS_SUCCESS = '[Collaborator] Reassign Splits Success';
export const REASSIGN_SPLITS_ERROR = '[Collaborator] Reassign Splits Error';

export const REMOVE_COLLABORATOR = '[Collaborator] Remove collaborator';
export const REMOVE_COLLABORATOR_SUCCESS =
  '[Collaborator] Remove collaborator Success';
export const REMOVE_COLLABORATOR_ERROR =
  '[Collaborator] Remove collaborator Error';

export const CLEAR_COLLABORATOR_STATE =
  '[Collaborator] Clear collaborator state';
